<template>
  <div class="body">
    <div class="success_text">
      <div>
        <img src="@/assets/images/mysuccess.png" class="success_img">
      </div>
      <div class="success_tit">秘钥设置成功</div>
    </div>
    <div class="footer">
      <el-button type="primary" @click="backToIndex">返回安全设置</el-button>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      merNo: null
    }
  },
  created() {
    const merNo = this.$route.params.merNo
    if (merNo == null) {
      this.$router.push({ path: '/crosspay/security/security/crossborderIndex' })
    }
  },
  methods: {
    backToIndex() {
      this.$router.push({ path: '/crosspay/security/security/crossborderIndex' })
    }
  }
}
</script>
<style scoped>
  .body{
    margin:0 auto;
    text-align: center;
  }
  .footer{
      padding-top:60px;
  }
  .success_text {
    text-align: center;
    font-size: 14px;
    color: #666666;
    padding-top:60px;
  }
  .success_tit {
    text-align: center;
    font-size: 20px;
    color: #333333;
    padding-top:20px;
  }
  .success_img {
    width: 84px;
    height: 84px;
  }
</style>

